import { createSiteAllowlistFlagFromVar } from "@/utils/siteAllowlistFlag";

/**
 * Offer Bank fields on the Coupon Codes page (FOG-2824): targeting, eligibility
 * window, default copy and the no-fallback warning. `VITE_FF_OFFER_BANK_FIELDS_SITES`
 * holds a comma-separated list of site ids, or `true` to enable everywhere.
 * Keep it off until the offer-bank backend accepts the new fields.
 */
const offerBankFieldsSiteCheck = createSiteAllowlistFlagFromVar(
  import.meta.env.VITE_FF_OFFER_BANK_FIELDS_SITES,
);

export const isOfferBankFieldsEnabled = (siteId: string | undefined) =>
  offerBankFieldsSiteCheck(siteId);
